"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _sha = _interopRequireDefault(require("sha1"));

var _fastStableStringify = _interopRequireDefault(require("fast-stable-stringify"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = function _default(queryName, args) {
  return "".concat(queryName, "_").concat((0, _sha.default)((0, _fastStableStringify.default)(args)));
};

exports.default = _default;